import React, { useCallback, useEffect } from 'react'
import { useInstData } from 'tyan/public/hooks'

import ListBox from './components/ListBox'

const Template = props => {
	const { text, path } = props
	// return <ButtonComponent className='e-flat e-primary' style={{ width: '100%' }}>{text}</ButtonComponent>
	return <div className="x-component x-button x-no-arrow x-has-text x-icon-align-left x-arrow-align-right x-user-selectable-text x-layout-box-item x-layout-hbox-item"
		style={{ margin: '0px 10px !important' }}>
		<div className="x-inner-el" >
			<div className="x-body-el" >
				{/* <div className="x-icon-el x-font-icon"></div> */}
				<div className="x-text-el" >{text}</div>
			</div>
			{/* <div className="x-arrow-el x-font-icon"></div> */}
		</div>
		{/* <div className="x-badge-el"></div>
		<button className="x-button-el" type="button" ></button> */}
	</div>
	return <div className='x-button-el' style={{ width: '100%', minHeight: '16px', fontSize: '16px' }}>{text}</div>
}


const MyTasks = props => {
	const { setState, me: { state: { data } } } = useInstData(props)

	const handleSelect = useCallback(data => {
		location.hash = '/TyanLims/' + data.path
	}, [])

	useEffect(() => {
		Tyan.doPostEvent({
			event: 'GetMyTasks',
			data: {},
			onEnd: ({ errorMessage, tasks }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				setState({ data: tasks })
			}
		})
	}, [])

	return <ListBox data={data} onSelect={handleSelect} template={Template} />
}

export default MyTasks